module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/equipment06-22fcd79ff22499cbd51ce062f8557070.png";